import React from "react";
import { Checkbox } from "antd";

const CustomCheckBox = ({ value, onChange, checklabel = "", ...props }) => {
  const handleChange = (e) => onChange(e.target.checked ? true : false);

  return (
    <Checkbox
      checked={value}
      value={value}
      onChange={(e) => handleChange(e)}
      {...props}
    >
      {checklabel}
    </Checkbox>
  );
};

export default CustomCheckBox;
